import React from 'react'
import { Typography } from 'antd'
import { Content, Description, ModeOptions } from './styled'
import { CardHeader, SectionCard } from '@/shared/ui/layout/styled'
import { Icon } from '@/shared/ui/Icon/Icon'
import { Radio } from '@/shared/ui/components/Radio'
import {
  TRANSFER_MODES,
  TransferMode,
} from '@/pages/transfer/model/transferTypes'
import { SYSTEM_TYPE, useSystemStore } from '@/app/store/systemStore'
import { getSystemDisplayName } from '@/shared/lib/getSystemDisplayName'

const { Text, Title } = Typography

export interface TransferModeCardProps {
  transferMode: TransferMode
  onTransferModeChange: (mode: TransferMode) => void
}

export const TransferModeCard: React.FC<TransferModeCardProps> = ({
  transferMode,
  onTransferModeChange,
}) => {
  const handleTransferModeChange = (e: any) => {
    onTransferModeChange(e.target.value)
  }

  const { selectedSystem } = useSystemStore()
  const isGlonassoft = selectedSystem === SYSTEM_TYPE.GLONASSOFT

  return (
    <SectionCard>
      <CardHeader gap={8}>
        <Icon name="transfer_mode" size={32} />
        <Title level={2}>Режим переноса</Title>
      </CardHeader>
      {!isGlonassoft && (
        <Content vertical gap={12}>
          <Description>Выберите сценарий.</Description>
          <Description>
            В режиме «<strong>Только сущности</strong>» вы сами выбираете
            объекты/пользователей/геозоны/водителей.
          </Description>

          <Description>
            В режиме «<strong>Полный перенос</strong>» переносится вся учетная
            запись {getSystemDisplayName(selectedSystem)} (с выбранными типами
            сущностей и сообщениями).
          </Description>
        </Content>
      )}

      <Radio.Group value={transferMode} onChange={handleTransferModeChange}>
        <ModeOptions vertical gap={12}>
          {isGlonassoft ? (
            <>
              <Radio value={TRANSFER_MODES.ENTITIES}>
                <Text strong>
                  Только сущности (Вы сами выбираете
                  объекты/пользователей/геозоны/водителей/ретрансляторы)
                </Text>
              </Radio>
              <Radio value={TRANSFER_MODES.FULL}>
                <Text strong>
                  Полный перенос (Переносится весь клиент ГЛОНАССSoft)
                </Text>
              </Radio>
            </>
          ) : (
            <>
              <Radio value={TRANSFER_MODES.ENTITIES}>
                <Text strong>Только сущности</Text>
              </Radio>
              <Radio value={TRANSFER_MODES.FULL}>
                <Text strong>Полный перенос</Text>
              </Radio>
            </>
          )}
        </ModeOptions>
      </Radio.Group>
    </SectionCard>
  )
}
